import About from "./components/About";
import Header from "./components/Header";
import Navbar from "./components/navbar";
import Skills from "./components/skills";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

export default function App() {
  return ( 
    <div>
      <BrowserRouter>
      <Routes>
        <Route index element={<Header />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/contact" element={<Contact />} />


      </Routes>
</BrowserRouter>
    </div>
  )
}


